//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { Y, N } from '@/scripts/constants/booleans'
import { WcsGetSupport } from '@/scripts/libs/wcs/get-support'

export default {
  name: 'rb-feedback',
  props: {
    elementId: {
      type: String,
    },
    pageName: {
      type: String,
    },
  },
  data() {
    return {
      title: 'Feedback Component',
      isError: false,
      formError: false,
      isFirstStep: true,
      isRequestSuccess: {
        yes: false,
        no: false,
      },
      answer: '',
      isNoOptions: false,
      feedbackReason: '',
      success: false,
      serverError: false,
      isFeedBackVisible: true,
      infoUnclear: 'INFO_UNCLEAR',
      infoNotNeeded: 'INFO_NOT_NEEDED',
    }
  },
  computed: {
    ...mapGetters(['translation']),
  },
  mounted() {
    if (
      (window.sessionStorage.getItem(`feedback.${this.pageName}`) && !this.elementId) ||
      (window.sessionStorage.getItem(`feedback.${this.pageName}.${this.elementId}`) &&
        this.elementId)
    ) {
      this.isFeedBackVisible = false
    }
  },
  validations: {
    feedbackReason: {
      required,
    },
  },
  methods: {
    triggerYesOption() {
      this.answer = Y
      this.submit()
    },
    triggerNoOption() {
      this.answer = N
      this.isFirstStep = false
      this.isNoOptions = true
    },
    saveFeedback() {
      if (!this.elementId) {
        window.sessionStorage.setItem(`feedback.${this.pageName}`, 'true')
      } else {
        window.sessionStorage.setItem(`feedback.${this.pageName}.${this.elementId}`, 'true')
      }
    },
    submitForm() {
      this.$v.$touch()

      if (!this.feedbackReason) {
        this.formError = true
      } else {
        this.submit()
      }
    },
    radioChange(e) {
      if (e) {
        this.formError = false
      }
    },
    triggerState() {
      if (this.answer === N) {
        this.formError = false
        this.isNoOptions = false
        this.isRequestSuccess.no = true
      } else {
        this.isFirstStep = false
        this.isRequestSuccess.yes = true
      }
    },
    async submit() {
      const { storeId, langId } = wcs.getStoreConfig()
      const requestBody = {
        storeId,
        langId,
        pageName: this.$props.pageName,
        elementId: this.$props.elementId,
        timeStamp: Date.now(),
        answer: this.answer,
        singleMotivation: this.feedbackReason,
      }
      try {
        const response = await WcsGetSupport.submitFeedback(requestBody)
        const { success, serverError } = response
        if (success) {
          this.success = success
          this.triggerState()
          this.saveFeedback()
        } else if (serverError) {
          this.serverError = serverError
          this.$ma.trackEvent({
            event: 'Error',
            value: {
              Error_Source: 'Get support - Feedback',
              Error_Message: 'Server error',
            },
          })
        }
      } catch (err) {
        this.serverError = err
        this.$ma.trackEvent({
          event: 'Error',
          value: {
            Error_Source: 'Get support - Feedback',
            Error_Message: 'Server error',
          },
        })
      }
    },
  },
}
